













































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { CalcState, CalcStatus } from "@/models/Models";
import CardIcon from "./CardIcon.vue";
import IssueSuccess from "./IssueSuccess.vue";
import IssueInProcess from './IssueInProcess.vue';
import BadEnd from './BadEnd.vue';
import Timer from "@/core/helpers/Timer";
import { TimeHelper } from "@/core/helpers/TimeHelper";
import { sortCalcsByPriority } from '@/utils/sortCalcsByPriority';
import { EventName, sendPostMessageEvent } from '@/utils/analyticMessages';

@Component({ components: { CardIcon, IssueSuccess, IssueInProcess, BadEnd } })
export default class IssueOther extends Vue {
    @Prop(Boolean) success;
    TimeHelper = TimeHelper;

    mounted() {
        this.startTimeout();
    }

    get isFastCalcDisabled() {
        return this.$store.direct.getters.isFastCalcDisabled;
    }

    get issuedCalcsLength(): number {
        return this.calcs.filter(x => x.status == CalcStatus.Issued).length;
    }

    get notRejectedCalcs(): CalcState[] {
        return this.calcs.filter(
            x =>
                ![CalcStatus.CalcFail, CalcStatus.NeedToSelectCar].includes(
                    x?.status
                )
        );
    }

    calcTimer: Timer = null;
    startTimeout() {
        this.calcTimer = new Timer(5 * 60 * 1000);
    }
    destroyed() {
        this.calcTimer?.dispose?.();
    }

    get isProcessing(): boolean {
        return this.calcs.some(x => x.status == CalcStatus.Processing);
    }

    get calcs() {
        const states = this.$store.direct.state.iccalc.calcStates;
        const currentProvId = this.$store.direct.state.iccalc.currentCalc?.insuranceProviderId;
        let calcs = states.filter(x => x.insuranceProviderId != currentProvId); // убрать выбранную из списка предложений
        //если таймер истек не показываем расчеты со спинерами
        if (this.calcTimer?.isEnd)
            calcs = calcs.filter(
                x =>
                    ![CalcStatus.NeedToCalc, CalcStatus.Processing].includes(
                        x.status
                    )
            );

        const priorityICSetting = this.$store.direct.getters.priorityICSetting;
        return sortCalcsByPriority(calcs, priorityICSetting)
            .filter((el) => el.status !== CalcStatus.NeedToSelectCar);
    }
    buyAnother(calc: CalcState) {
        const selectedIc = this.$store.direct.state.dicti.providers.find(
            x => x.code == calc.insuranceProviderId
        ).code; // hmmmmmm
        console.log("selected calc", calc);

        sendPostMessageEvent(EventName.ApplyFullCalcIc, calc.insuranceProviderId);

        this.$store.direct.commit.iccalc.setCurrentCalc(calc);
        this.$store.direct.commit.iccalc.setInsuranceIssue(calc);
        this.$store.direct.commit.iccalc.disposeChecker();
    }
}
